import { proxy } from "valtio";

import type { State } from "./types";

export const state = proxy<State>({
  status: "BEFORE_RESET_PASSWORD",
  mailAddress: "",
});
